var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Highlighter from 'react-highlight-words';
import classnames from 'classnames';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import useResourceTree from '@/shared/hooks/resource/useResourceTree';
import { retrieveResources } from '@/shared/components/registration/resourceApi';
var messages = defineMessages({
    EnterResource: {
        id: 'EnterResource',
        defaultMessage: 'Enter resource',
    },
});
export var ResourceMultiSelect = function (_a) {
    var selection = _a.selection, _b = _a.resourceTypes, resourceTypes = _b === void 0 ? null : _b, _c = _a.resourceType, resourceType = _c === void 0 ? -1 : _c, onChange = _a.onChange, placeholder = _a.placeholder, _d = _a.small, small = _d === void 0 ? false : _d;
    var intl = useIntl();
    var _e = useState([]), allResources = _e[0], setResources = _e[1];
    var resources = useMemo(function () {
        if (!resourceTypes || resourceTypes.length === 0)
            return allResources;
        return allResources.filter(function (r) { return resourceTypes.includes(r.type); });
    }, [resourceTypes, allResources]);
    var items = useResourceTree(resources, intl);
    useEffect(function () {
        retrieveResources(intl, resourceType).then(function (response) {
            setResources(response);
        });
    }, [intl]);
    var renderItem = useCallback(function (item, searchValue, index) {
        var showCategory = item.level === 1 && (index === 0 || item.categoryId !== items[index - 1].categoryId);
        return (_jsxs("div", { children: [showCategory ? (_jsx("div", __assign({ className: "margin-10L" }, { children: searchValue ? (_jsx(Highlighter, { highlightClassName: "bold", searchWords: [searchValue], textToHighlight: item.categoryLabel })) : (item.categoryLabel) }))) : null, _jsx("div", __assign({ className: classnames({
                        'margin-10L': item.level === 0,
                    }) }, { children: searchValue ? (_jsx(Highlighter, { highlightClassName: "bold", searchWords: [searchValue], textToHighlight: item.label })) : (item.label) }))] }));
    }, [items]);
    var _f = splitItems(items, selection), selectedItems = _f[0], selectableItems = _f[1];
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: function (item) { return onChange(removeItem(selection, item)); }, onItemSelected: function (item) { return onChange(addItem(selection, item)); }, items: selectableItems, placeholder: placeholder || intl.formatMessage(messages.EnterResource), isSmall: small, renderItem: renderItem, searchProps: ['search', 'label'] }));
};
export default ResourceMultiSelect;
